import React, { useEffect, useState } from 'react';

import { LinearProgress, Grid, makeStyles, withStyles, Box, Container } from '@material-ui/core';

import logo from '../assets/logo (2).png'
import normalise from '../utils/NormalizeProgress'
import storageManager from '../utils/LocalStorageManager'

import DataManagerButtons from './DataManagerButtons'
import ModalEditStats from './ModalEditStats'
import PointsArrow from './PointsArrow'
import Inventory from './Inventory'
import IconDiceButton from './IconDiceButton'
import Skills from './Skills'
import GameComponent from './GameComponent'
import Dices from './Dices'
import ComponentToolbar from './ComponentToolbar';
import Websocket from './Websocket'
import DiceWebsocket from './DiceWebsocket';
import websocket from '../utils/WebsocketConnection';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    color: 'rgb(255,255,255)'
  },
  divGridDiceList: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '40px',
    marginTop: '40px',
    border: '2px solid white',
    height: 'auto',
  },
  statsBar: {
    width: '15rem',
  },
  logo: {
    display: 'flex',
    width: '500px',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '10px'
  },
  loadingPage: {
    minHeight: '100vh'
  },
  ficha: {
    backgroundImage: 'linear-gradient(to right bottom, #2e2e2e, #2c2c2c, #2a2a2a, #292929, #272727, #282829, #29282c, #2b292e, #312c34, #382e39, #40313e, #483341)',
  },
  container: {
    color: 'rgb(255, 255, 255)',
  },
  status: {
    textAlign: 'right',
    /* align-items: center; */
    marginTop: 'auto',
    marginBottom: 'auto',
    color: 'rgb(223, 142, 244)',

    '& > h2': {
      display: 'flex',
      justifyContent: 'center',
      '& > *': {
        marginLeft: '6px',
      },
    }
  },

  ability: {
    textAlign: 'left',
    margiTop: 'auto',
    margiBottom: 'auto',
    color: 'rgb(242, 122, 122)',

    '& > h3': {
      display: 'flex',
      textAlign: 'left',
      '& > *': {
        marginLeft: '6px',
      },
    }
  },

  grid: {
    display: 'grid',
    gridColumnGap: '30px',
    gridTemplateColumns: 'auto 300px auto',
  },

  center: {
    /* margin: auto; */
    textAlign: 'center',
    color: 'white'
  },

  info: {
    '& > h2': {
      margin: '0',
      marginTop: '10px',
      color: 'rgb(121, 129, 251)',
    },
    '& > h1': {
      margin: '0'
    }
  },

  others: {
    '& > h2': {
      margin: '0',
      marginTop: '10px',
      color: 'rgb(173, 251, 121)',
    },
    '& > h1': {
      margin: '0'
    }
  },

  profileDiv: {
  },

  profilePic: {
    borderRadius: '50%',
    border: '3px solid rgb(255, 255, 255)',

    objectFit: 'cover',
    objectPosition: 'center center',
    width: '100%',

    aspectRatio: '1/1',
  },
}));

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[700],
  },
  bar: {
    // borderRadius: 5,
    backgroundImage: 'radial-gradient(circle, rgba(255, 255, 255, 0.5) 0%, rgba(223, 142, 244,1) 100%)',
  },
}))(LinearProgress);

const Ficha = () => {
  const classes = useStyles();


  const [userData, setUserData] = useState(null)
  const [info, setInfo] = useState(null)
  const [stats, setStats] = useState(null)
  const [attributes, setAttributes] = useState(null)
  const [skills, setSkills] = useState(null)
  const [inventory, setInventory] = useState(null)
  const [other, setOther] = useState(null)

  const [connected, setConnected] = useState(false)

  useEffect(() => {
    setUserData(storageManager.getData())
  }, [])

  useEffect(() => {
    if (userData == null)
      return
    setInfo(userData.info)
    setStats(userData.stats)
    setAttributes(userData.attributes)
    setSkills(userData.skills)
    setInventory(userData.inventory)
    setOther(userData.other)
  }, [userData])

  useEffect(() => {
    async function updateData() {
      if (info && stats && attributes && skills && other) {
        const data = {
          info: info,
          stats: stats,
          attributes: attributes,
          skills: skills,
          inventory: inventory,
          other: other
        }
        storageManager.updateData(data)
        if (connected) websocket.updateData(data)
      }
    }
    updateData()
  }, [info, stats, attributes, skills, inventory, other, connected])

  const content = () => {
    if (info && stats && attributes && skills) {
      return (
        <React.Fragment>

          <img className={classes.logo} src={logo} alt="logo" />

          <Grid
            // className={classes.grid}
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={4}
          >

            <Grid
              item
              className={classes.status}
              container
              alignItems="flex-end"
              direction="column"
              xs={12}
              sm={4}
            >
              <ModalEditStats valueState={stats} setState={setStats} onlyNumeric={true} />

              <h2 justify="center">{stats.vida} - Vida <PointsArrow valueState={stats} setState={setStats} field={'vida'} /></h2>
              <BorderLinearProgress className={classes.statsBar} variant="determinate" value={normalise(stats.vida, stats.vida_max)} />

              <h2>{stats.sanidade} - Sanidade <PointsArrow valueState={stats} setState={setStats} field={'sanidade'} /></h2>
              <BorderLinearProgress className={classes.statsBar} variant="determinate" value={normalise(stats.sanidade, stats.sanidade_max)} />

              <h2><IconDiceButton skillName={"E. Paranormal"} skillValue={stats.exposicao_paranormal} paranormalDice={true}/> {stats.exposicao_paranormal} - E. Paranormal <PointsArrow valueState={stats} setState={setStats} field={'exposicao_paranormal'} /></h2>
              <BorderLinearProgress className={classes.statsBar} variant="determinate" value={normalise(stats.exposicao_paranormal, stats.exposicao_paranormal_max)} />
            </Grid>

            <Grid
              // className={classes.profileDiv}
              item
              xs={12}
              sm={4}
            >
              <img alt={'photo ' + info.nome} src={info.image} className={classes.profilePic}></img>
            </Grid>

            <Grid
              className={classes.ability}
              item
              xs={12}
              sm={4}
            >
              <ModalEditStats valueState={attributes} setState={setAttributes} onlyNumeric={true} />
              <h3>Aparência - {attributes.aparencia} <IconDiceButton skillName={"Aparência"} skillValue={attributes.aparencia} /></h3>
              <h3>Constituição - {attributes.constituicao} <IconDiceButton skillName={"Constituição"} skillValue={attributes.constituicao} /></h3>
              <h3>Destreza - {attributes.destreza} <IconDiceButton skillName={"Destreza"} skillValue={attributes.destreza} /></h3>
              <h3>Força - {attributes.forca} <IconDiceButton skillName={"Força"} skillValue={attributes.forca} /></h3>
              <h3>Inteligência - {attributes.inteligencia} <IconDiceButton skillName={"Inteligência"} skillValue={attributes.inteligencia} /></h3>
              <h3>Poder - {attributes.poder} <IconDiceButton skillName={"Poder"} skillValue={attributes.poder} /></h3>
              <h3>Sorte - {attributes.sorte} <IconDiceButton skillName={"Sorte"} skillValue={attributes.sorte} /></h3>
              <h3>Movimento - {attributes.movimento}</h3>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={12} sm={6}>
              <GameComponent >
                <ComponentToolbar title={'Informações'}>
                  <ModalEditStats valueState={info} setState={setInfo} />
                </ComponentToolbar>

                <Box className={`${classes.center} ${classes.info}`}>
                  <h2>Nome</h2>
                  <h1>{info.nome}</h1>
                  <h2>Jogador</h2>
                  <h1>{info.jogador}</h1>
                  <h2>Idade</h2>
                  <h1>{info.idade}</h1>
                  <h2>Sexo</h2>
                  <h1>{info.sexo}</h1>
                </Box>
              </GameComponent>
            </Grid>


            <Grid item xs={12} sm={6}>
              <GameComponent item>
                <ComponentToolbar title={'Outros'}>
                  <ModalEditStats valueState={other} setState={setOther} />
                </ComponentToolbar>

                <Box className={`${classes.center} ${classes.others}`}>
                  <h2>Carreira</h2>
                  <h1>{other.carreira}</h1>
                  <h2>Pessoas Importantes</h2>
                  <h1>{other.pessoas_importantes}</h1>
                  <h2>Percences Queridos</h2>
                  <h1>{other.percences_queridos}</h1>
                  <h2>Locais Importantes</h2>
                  <h1>{other.locais_importantes}</h1>
                </Box>
              </GameComponent>
            </Grid>

          </Grid>




          <GameComponent>
            <Inventory inventory={inventory} setInventory={setInventory} />
          </GameComponent>

          <GameComponent>
            <Skills skills={skills} setSkills={setSkills} />
          </GameComponent>

          <Dices />

          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            col={12}>
            <Websocket connected={connected} setConnected={setConnected} />
            <DataManagerButtons />
          </Grid>



        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <Grid
            className={classes.loadingPage}
            container
            direction="column"
            justify="center"
            alignItems="center"
            col={12}>
            <DataManagerButtons />
          </Grid>
        </React.Fragment>
      )
    }
  }

  return (

    <div className={classes.ficha}>
      <Container className={classes.container}>
        {content()}
      </Container>
    </div>
  );
}
export { Ficha }